export const disallowedRedirectPaths = ['/register', '/login', '/logout'];
